module.exports = __webpack_public_path__ + "assets/img/cwbx.17279d01.jpg";